import React from "react";
import { ProgressBar } from "../ProgressBar";

const Intro = ({ goToNextStep, resetDonation, total }) => {
  const handleStart = () => {
    resetDonation();
    goToNextStep();
  };
  return (
    <>
      <section className="intro" id="campaign-intro" data-colour="#c5dbf4">
        <div>
          <h2 className="heading">New Building, New Home</h2>
          <p className="text-size-medium bold">Help us reach our stretch goal!</p>
        </div>

        <div>
          <p className="text-size-medium">Campaign Progress</p>
          <ProgressBar moneyRaised={total} />
        </div>

        <div>
          <p>Thanks to everyone who bought a brick and supported the home stretch of our campaign, we have raised the $1.2 million that was required to unlock a $3.5 million donation from a generous private foundation!</p>
          <p>This means we’ve officially hit our overall target of $39 million!</p>
          <p className="bold">To help ensure a strong start and smooth transition once we’re in our new home, will you buy the last brick and help us reach our stretch goal of $40 million?</p>
          <p>Your donation will help us start strong in our new building. Gifts will help cover important costs related to furnishing and activating our space, program startup in the building, contingency planning, and long-term sustainability.Buy the last brick today and help us be in the best position to provide dignity, belonging and justice when we open our new building to the community!</p>
        </div>

        <ul className="intro-actions">
          <button onClick={handleStart} className="button button--cta button--block">
            Buy a Brick for $50
          </button>

          <div className="intro-actions-links">
            <a href="https://firstunited.ca/donate-now/donate-to-first-forward" className="button button--s">
              Donate less than $50
            </a>

            <a href="https://firstunited.ca/buy-a-brick-corporate-sponsorships/" className="button button--s">
              Become a Corporate Donor
            </a>

            <a href="tel:+16043363047" className="button button--s">
              Need help buying A LOT of bricks? Call us at 604.336.3047
            </a>
          </div>
        </ul>

        <p className="text-size-xsmall">
          Donations received in excess of our goal will be restricted to start-up costs associated with operating out of our new building and long-term upgrades and replacements of the facility.
        </p>
      </section>
    </>
  );
};

export { Intro };
